<p-dialog [(visible)]="display" header="{{title}}" [modal]="true" [style]="{width: '70vw'}" (onHide)="closeModal()" [focusOnShow]="false">
  <form class="card mt-2" [formGroup]="form" (ngSubmit)="saveBenefitSettingsEdits()">
    <div class="card-body">
      <div class="row">
        <div class="col-12">

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Open Enrollment Start Date</b>
            </div>
            <div class="col-8">
              <input type="date" class="form-control mt-2" formControlName="openEnrollmentStart" />
              <app-validation-message [form]="form" [path]="'openEnrollmentStart'" [label]="'Open Enrollment Start'"></app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>Open Enrollment End Date</b>
            </div>
            <div class="col-8">
              <input type="date" class="form-control mt-2" formControlName="openEnrollmentEnd" />
              <app-validation-message [form]="form" [path]="'openEnrollmentEnd'" [label]="'Open Enrollment End'"></app-validation-message>
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>IRS Single Contribution Limit</b>
            </div>
            <div class="col-8">
              <input type="number" min="0" step="1" class="form-control mt-2" formControlName="irsContributionLimit" />
              <app-validation-message [form]="form" [path]="'irsContributionLimit'" [label]="'IRS Single Contribution Limit'"></app-validation-message>              
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>IRS Family Contribution Limit</b>
            </div>
            <div class="col-8">
              <input type="number" min="0" step="1" class="form-control mt-2" formControlName="familyYearlyContribution" />
              <app-validation-message [form]="form" [path]="'familyYearlyContribution'" [label]="'IRS Family Contribution Limit'"></app-validation-message>              
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>IRS Catch-up Contribution Limit</b>
            </div>
            <div class="col-8">
              <input type="number" min="0" step="1" class="form-control mt-2" formControlName="catchUpContribution" />
              <app-validation-message [form]="form" [path]="'catchUpContribution'" [label]="'IRS Catch-up Contribution Limit'"></app-validation-message>              
            </div>
          </div>

          <div class="row">
            <div class="col-4 d-flex align-items-center">
              <b>IRS Catch-up Contribution Starting Age</b>
            </div>
            <div class="col-8">
              <input type="number" min="0" step="1" class="form-control mt-2" formControlName="catchUpContributionStartingAge" />
              <app-validation-message [form]="form" [path]="'catchUpContributionStartingAge'" [label]="'Catch-up Contribution Starting Age'"></app-validation-message>
            </div>
          </div>

        </div>
      </div>
    </div>
  </form>
  <ng-template pTemplate="footer">
    <div class="row w-100 m-0">
      <div class="col-5 text-left pl-0">
        <i class="material-icons rotate text-muted" *ngIf="disableButtons">loop</i>
        <button class="btn btn-secondary ml-2" type="button" (click)="closeModal()">Cancel</button>
      </div>
      <div class="col-2 text-center"></div>
      <div class="col-5 text-right pr-0">
        <button class="btn btn-primary" type="submit" (click)="saveBenefitSettingsEdits()" [disabled]="disableButtons">Save</button>
      </div>
    </div>
  </ng-template>
</p-dialog>
